import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ProviderCard from '../components/ProviderCard';
import { useFavorites } from '../context/FavoritesContext';
import { fetchProviderById } from '../api/client';

export default function Favoritos() {
  const { favorites } = useFavorites();
  const [favoriteProviders, setFavoriteProviders] = useState([]);
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    if (favorites.length === 0) {
      setFavoriteProviders([]);
      setStatus('ready');
      return;
    }
    let active = true;
    setStatus('loading');
    Promise.allSettled(favorites.map((id) => fetchProviderById(id))).then((results) => {
      if (!active) return;
      setFavoriteProviders(
        results.filter((r) => r.status === 'fulfilled').map((r) => r.value)
      );
      setStatus('ready');
    });
    return () => {
      active = false;
    };
  }, [favorites]);

  return (
    <section className="section page-section">
      <div className="section-header">
        <h1>Mis favoritos</h1>
        <p>Los proveedores que guardaste para comparar más tarde.</p>
      </div>
      {status === 'ready' && favoriteProviders.length > 0 && (
        <div className="provider-grid">
          {favoriteProviders.map((p) => <ProviderCard provider={p} key={p.id} />)}
        </div>
      )}
      {status === 'ready' && favoriteProviders.length === 0 && (
        <div className="empty-state">
          <p>Aún no has guardado ningún proveedor.</p>
          <Link to="/categorias" className="btn btn-primary">Explorar categorías</Link>
        </div>
      )}
    </section>
  );
}
